import { blue, common } from '@mui/material/colors';
import { BoardColumnEntity } from 'components/shared/Board/types';

import { DealPipelineListItem } from '../types';

export function generateBoardColumns(
  groupedVOs: {
    groupName: string;
    list: DealPipelineListItem[];
  }[]
) {
  const res: BoardColumnEntity<DealPipelineListItem>[] = [];

  groupedVOs.forEach(({ groupName, list }) => {
    res.push({
      id: groupName,
      cards: list,
      title: groupName,
      metaData: {
        isSupportDAD: !['LOST', 'WON'].includes(groupName),
        nameColor: !['LOST', 'WON'].includes(groupName) ? common.black : blue[600],
      },
    });
  });

  return res;
}
